(function () {
  var sections = Array.from(document.querySelectorAll('[data-bavi-continuous-motion]'));

  function setupSection(section) {
    if (section.dataset.baviMotionReady === 'true') return;
    section.dataset.baviMotionReady = 'true';
    section.dataset.motionActive = 'true';
  }

  sections.forEach(setupSection);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-bavi-continuous-motion]');
    if (!section) return;
    sections.push(section);
    setupSection(section);
  });

})();
